/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateUserDto } from '../models/CreateUserDto';
import type { UpdateUserDto } from '../models/UpdateUserDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UsersService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Listar usuarios (paginado)
   * @returns any Lista de usuarios con paginación
   * @throws ApiError
   */
  public usersControllerFindAll({
    page = 1,
    limit = 10,
    search,
    role,
    status,
    sortBy = 'name',
    sortOrder = 'asc',
  }: {
    /**
     * Número de página (1-indexed)
     */
    page?: number,
    /**
     * Cantidad de registros por página
     */
    limit?: number,
    /**
     * Búsqueda por nombre o email
     */
    search?: string,
    /**
     * Filtrar por rol
     */
    role?: 'admin' | 'operator' | 'viewer',
    /**
     * Filtrar por estado
     */
    status?: 'PENDING_ACTIVATION' | 'ACTIVE' | 'INACTIVE',
    /**
     * Campo de ordenamiento (name, email, role, createdAt, lastLoginAt)
     */
    sortBy?: string,
    /**
     * Dirección de ordenamiento
     */
    sortOrder?: 'asc' | 'desc',
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/users',
      query: {
        'page': page,
        'limit': limit,
        'search': search,
        'role': role,
        'status': status,
        'sortBy': sortBy,
        'sortOrder': sortOrder,
      },
      errors: {
        401: `No autenticado`,
        403: `Permisos insuficientes`,
      },
    });
  }
  /**
   * Crear nuevo usuario
   * @returns any Usuario creado exitosamente. Se envía email de activación.
   * @throws ApiError
   */
  public usersControllerCreate({
    requestBody,
  }: {
    requestBody: CreateUserDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/users',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Datos inválidos`,
        401: `No autenticado`,
        403: `Permisos insuficientes`,
        409: `Ya existe un usuario con este email`,
      },
    });
  }
  /**
   * Obtener usuario por ID
   * @returns any Detalles del usuario
   * @throws ApiError
   */
  public usersControllerFindOne({
    id,
  }: {
    /**
     * ID del usuario (UUID)
     */
    id: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/users/{id}',
      path: {
        'id': id,
      },
      errors: {
        401: `No autenticado`,
        403: `Permisos insuficientes`,
        404: `Usuario no encontrado`,
      },
    });
  }
  /**
   * Actualizar usuario
   * @returns any Usuario actualizado exitosamente
   * @throws ApiError
   */
  public usersControllerUpdate({
    id,
    requestBody,
  }: {
    /**
     * ID del usuario (UUID)
     */
    id: string,
    requestBody: UpdateUserDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/users/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Datos inválidos`,
        401: `No autenticado`,
        403: `Permisos insuficientes`,
        404: `Usuario no encontrado`,
      },
    });
  }
  /**
   * Eliminar usuario (soft delete)
   * @returns any Usuario eliminado exitosamente
   * @throws ApiError
   */
  public usersControllerRemove({
    id,
  }: {
    /**
     * ID del usuario (UUID)
     */
    id: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/users/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `No puede eliminar su propia cuenta`,
        401: `No autenticado`,
        403: `Permisos insuficientes`,
        404: `Usuario no encontrado`,
      },
    });
  }
}
